// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"_3oAYZLK748B3Uo9Vc_x6cC"};